export const TOP_NAVIGATION_HEIGHT = '60px';
export const ENTER_KEY_CODE = 13;
export const SPACEBAR_KEY_CODE = 32;
